// Dependencies
require("webstrap/type");
require("webstrap/forms");
require("webstrap/buttons");
require("grid");
require("section/generic");
require("element/rich-text");

// JavaScript
var $ = jQuery = require('jquery');

if ($('.js-form-contact').length > 0) {
    require("forms-validation");
    $('.js-form-contact').validate(require("forms-validation/options/defaults.js"));
}


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/contact/index.js
 ** module id = 176
 ** module chunks = 0 1
 **/